// extracted by mini-css-extract-plugin
export var cartIcon = "_o1-0";
export var cartIconContainer = "_o1-1";